import { useContext } from 'react';
import { SwrRequestKeysToMutateContext } from '../contexts/swrRequestKeysToMutate';

export const useSwrRequestKeysToMutateFromContext = () => useContext(SwrRequestKeysToMutateContext);
